export default [
	/* **** */
	{
		path: '/log',
		layout: 'Admin',
		component: 'Log',
		meta: {
			name: 'Лог событий',
		},
	},
	/* **** */
];
